import { render } from "./SpecialSection.vue?vue&type=template&id=d071a5c6"
import script from "./SpecialSection.vue?vue&type=script&lang=js"
export * from "./SpecialSection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__